import { IProgramActivity } from "../../../../domain/core/entities/programActivityEntity";
import { IProgram, IProgramFeatures } from "../../../../domain/core/entities/programEntity";
import firebase from "firebase/app";

export function fromFirebaseMap(data: any, programActivities?: IProgramActivity[] | null): IProgram {
  const programFeatures: IProgramFeatures = {
    species: data?.features?.species ?? "",
    breed: data?.features?.breed ?? "",
  }

  return {
    programId: data?.programId ?? "",
    programCategoryId: data?.programCategoryId ?? "",
    programCategory: data?.programCategory ?? "",
    name: data?.name ?? "",
    programActivities: programActivities ?? [],
    status: data?.status ?? "",
    description: data?.description ?? "",
    isTherePrecedence: data?.isTherePrecedence ?? false,
    isThereValidityConstraint: data?.isThereValidityConstraint ?? false,
    validityStartDate: data?.validityStartDate ?? null,
    validityEndDate: data?.validityEndDate ?? null,
    contractType: data?.contractType ?? "",
    amount: data?.amount ?? null,
    currency: data?.currency ?? "",
    tags: data?.tags ?? [],
    features: programFeatures,
    isDelete: data?.isDelete ?? false,
    createdOn: data?.createdOn ?? null,
    updatedOn: data?.updatedOn ?? null,
  } as IProgram;
}

export function fromFirebaseToDocumentData(program: IProgram): firebase.firestore.DocumentData {
  const programJSON = {
    programId: program.programId,
    programCategoryId: program.programCategoryId,
    programCategory:  program.programCategory,
    name: program.name,
    status: program.status,
    description: program.description,
    isTherePrecedence: program.isTherePrecedence,
    isThereValidityConstraint: program.isThereValidityConstraint,
    validityStartDate: program.validityStartDate,
    validityEndDate: program.validityEndDate,
    contractType: program.contractType,
    amount: program.amount ?? null,
    currency: program.currency,
    tags: program.tags ?? [],
    features: program.features,
    isDelete: program.isDelete,
    createdOn: program.createdOn,
    updatedOn: program.updatedOn,
  } as firebase.firestore.DocumentData;

  return programJSON;
}
